<template>
  <BaseModalShell
    id="two-factor-invitation"
    aria-labelledby="two-factor-invitation-title"
    aria-describedby="two-factor-invitation-description"
    :visible="store.invitationVisible"
    @hidden="store.closeInvitation()"
  >
    <section
      ref="dialogContent"
      aria-labelledby="two-factor-invitation-title"
      aria-describedby="two-factor-invitation-description"
      @keydown="handleKeydown"
    >
      <div class="modal-header">
        <h2 id="two-factor-invitation-title" class="modal-title h5">{{ t('twoFactor.invitationTitle') }}</h2>
        <button type="button" class="close" :aria-label="t('Close')" @click="store.closeInvitation()">&times;</button>
      </div>
      <div class="modal-body">
        <p id="two-factor-invitation-description">{{ t('twoFactor.invitationDescription') }}</p>
        <p v-if="store.dismissError" role="alert" class="text-danger mb-0">{{ t('twoFactor.dismissError') }}</p>
      </div>
      <div class="modal-footer">
        <button ref="laterButton" type="button" class="btn btn-outline-secondary" :disabled="store.dismissLoading" @click="store.dismissInvitation()">
          {{ t('twoFactor.later') }}
        </button>
        <button type="button" class="btn btn-primary" :disabled="store.dismissLoading" @click="openSecurity">
          {{ t('twoFactor.activate') }}
        </button>
      </div>
    </section>
  </BaseModalShell>
</template>

<script>
import { defineComponent, nextTick, onBeforeUnmount, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import BaseModalShell from '@core/components/bootstrap/BaseModalShell.vue'
import { useTwoFactorStore } from '@/stores/twoFactorStore'

export default defineComponent({
  components: { BaseModalShell },
  setup() {
    const store = useTwoFactorStore()
    const router = useRouter()
    const { t } = useI18n({ useScope: 'global' })
    const dialogContent = ref(null)
    const laterButton = ref(null)
    let previousFocus = null
    const restoreFocus = () => {
      if (previousFocus?.isConnected) previousFocus.focus()
      previousFocus = null
    }
    watch(() => store.invitationVisible, async visible => {
      if (!visible) {
        restoreFocus()
        return
      }
      previousFocus = document.activeElement
      await nextTick()
      if (store.invitationVisible) laterButton.value?.focus()
    }, { immediate: true })
    onBeforeUnmount(restoreFocus)
    const handleKeydown = event => {
      if (event.key === 'Escape') {
        event.preventDefault()
        store.closeInvitation()
      }
      if (event.key !== 'Tab') return
      const controls = [...(dialogContent.value?.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), [tabindex="0"]') || [])]
      if (!controls.length) return
      const first = controls[0]
      const last = controls[controls.length - 1]
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }
    const openSecurity = () => {
      store.closeInvitation()
      router.push({ name: 'pages-account-setting', query: { tab: 'security' } })
    }
    return { t, store, dialogContent, laterButton, handleKeydown, openSecurity }
  },
})
</script>
